import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class NotClickableComponent extends BaseComponent {
    constructor(){
        super();
        this.componentType = ComponentNames.notClickableComponent;
    }
}